import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ElectricalHero from './components/ElectricalHero';
import ElectricalServices from './components/ElectricalServices';
import ElectricalServicesElPaso from './components/ElectricalServicesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import ElectricalFAQ from './components/ElectricalFAQ';

export default function ElectricalPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <ElectricalHero />
        <ElectricalServices />
        <ElectricalServicesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <ElectricalFAQ />
      </main>
      <Footer />
    </div>
  );
}
